export const endpoints = {
  searchTexts: 'translation/search',
  languageOptions: 'translation/language/options',
  textCollectionOptions: 'translation/textCollection/options',
  textSetAllOptions: 'translation/textSet/all/options',

  saveTexts: 'translations/text',

  text: (textSet: number) => `translation/textSet/${textSet}/text`,
  createText: 'translation',

  textSetOptions: 'translation/textSet/options',

  exportToExcel: 'translation/export/excel',

  importFromExcel: 'translation/import/excel',

  codeDescriptionMetadata: 'translation/code/metadata',

  searchCodeDescription: 'translation/code/search',

  saveCodeDescription: 'translations/code/description',

  exportCodeDescriptionToExcel: 'translation/code/export/excel',

  importCodeDescriptionFromExcel: 'translation/code/import/excel',

  codetableOptions: 'translation/optionsCollection/options',

  translationTypes: 'translation/type/options'
};
